document.addEventListener("DOMContentLoaded", () => {
  function getUpdatedID(url) {
    return fetch(`${url}.js`)
      .then((response) => response.json())
      .then((product) => {
        const productID = Number(product.id);
        const variantID = product.variants?.[0]?.id
          ? Number(product.variants[0].id)
          : null;

        console.log("Product ID:", productID);
        console.log("Variant ID:", variantID);

        return { productID, variantID }; // return both in an object
      })
      .catch((error) => {
        console.error("Failed to fetch product JSON:", error);
        return { productID: null, variantID: null };
      });
  }

  // Get cookie value (decoded JSON)
  function getCookie(name) {
    const cookie = document.cookie
      .split("; ")
      .find((row) => row.startsWith(name + "="));
    if (!cookie) return null;
    try {
      return JSON.parse(decodeURIComponent(cookie.split("=")[1]));
    } catch (e) {
      return null;
    }
  }

  let all_cards = document.querySelectorAll(".nc-product-card");
  let all_cc_item = document.querySelectorAll(".cc-item");
  // alert("Test Cookie ");

  all_cards.forEach((card) => {
    let cookie_name = card.dataset.cookiename;
    let marketing_action = card.dataset.marketingaction;

    if (cookie_name && marketing_action === "Get Cookie") {
      let cookie_data = getCookie(cookie_name);
      let cookie_value = cookie_data?.value;

      if (cookie_value) {
        // update url
        let urls = card.querySelectorAll("a");
        urls.forEach((url) => {
          url.setAttribute("href", cookie_value);
        });

        // Update ATC button
        // product_form_8893925032281
        let form = card.querySelector("form");
        let variantiD = card.querySelector('input[type="hidden"][name="id"]');
        let oldProductID = card.querySelector(
          'input[type="hidden"][name="product-id"]'
        );
        let updatedID = 0;

        getUpdatedID(cookie_value).then(({ productID, variantID }) => {
          console.log("Returned Product ID:", productID);
          console.log("Returned Variant ID:", variantID);

          // Use as needed
          if (productID && variantID) {
            variantiD.value = variantID;
            oldProductID.value = productID;
            form.id = "product_form_" + productID;
          }
        });
      }
    }
  });

  all_cc_item.forEach((card) => {
    let cookie_name = card.dataset.cookiename;
    let marketing_action = card.dataset.marketingaction;

    if (cookie_name && marketing_action === "Get Cookie") {
      let cookie_data = getCookie(cookie_name);
      let cookie_value = cookie_data?.value;

      if (cookie_value) {
        // update url
        let urls = card.querySelectorAll("a");
        urls.forEach((url) => {
          url.setAttribute("href", cookie_value);
        });
      }
    }
  });
});
